import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from './Tooltip';

import { Colors, FontSizes, FontWeights } from '../Theme';

const Field = ({ action, children, description, invalid, label, style = {}, tooltip, tooltipProps }) => {
  const styles = {
    component: Object.assign(
      {},
      {
        marginBottom: 20
      },
      style
    ),
    label_wrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      lineHeight: 1,
      marginBottom: 6
    },
    label: {
      color: invalid ? Colors.RED.hex : Colors.GRAY.hex,
      display: 'flex',
      fontSize: FontSizes.REGULAR,
      lineHeight: '1.5em',
      verticalAlign: 'center',
      width: tooltipProps && tooltipProps.error && '100%'
    },
    action: {
      color: Colors.PRIMARY.hex,
      cursor: 'pointer',
      fontSize: FontSizes.REGULAR,
      fontWeight: FontWeights.MEDIUM,
      lineHeight: '1.5em'
    },
    description: {
      marginBottom: 6,
      fontSize: FontSizes.SMALL,
      lineHeight: '1.5em',
      color: '#999999'
    }
  };

  return (
    <div style={styles.component}>
      {label ? (
        <div style={styles.label_wrapper}>
          <div style={styles.label}>
            {label}
            {tooltip ? <Tooltip {...tooltipProps}>{tooltip}</Tooltip> : null}
          </div>
          {action ? (
            <span onClick={action.onClick} style={styles.action}>
              {action.label}
            </span>
          ) : null}
        </div>
      ) : null}
      {description ? <div style={styles.description}>{description}</div> : null}
      {children}
    </div>
  );
};

Field.propTypes = {
  action: PropTypes.shape({
    label: PropTypes.node.isRequired,
    onClick: PropTypes.func
  }),
  description: PropTypes.string,
  invalid: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.node,
  tooltipProps: PropTypes.object
};

export default Field;
